import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AbPortaEquipamentoPac } from "app/abstract/full-pages/equipamento-pac/porta-equipamento-pac.abstract";
import {
  ConfigQrCodePortaForm,
  GeolocalizacaoPortaForm,
  LogGeolocalizacaoPorta,
  LogQrCodePorta,
  LogReplicacaoPorta,
  PortaEquipamentoPac,
  PortaEquipamentoPacForm,
  ReplicarConfigPorta
} from "app/pages/full-pages/equipamento-pac/equipamento-pac.models";

@Injectable({ providedIn: 'root' })
export class PortaEquipamentoPacService extends AbPortaEquipamentoPac {

  public prefixo: string = "api/v1/equipamentos-pac/";

  constructor(http: HttpClient) {
    super(http);
  }

  public listarPortas(equipamentoId: number): Observable<PortaEquipamentoPac[]> {
    return this.get(`${this.prefixo}${equipamentoId}/portas`);
  }

  public buscarPorta(equipamentoId: number, portaId: number): Observable<PortaEquipamentoPac> {
    return this.get(`${this.prefixo}${equipamentoId}/portas/${portaId}`);
  }

  public salvar(equipamentoId: number, portaId: number, form: PortaEquipamentoPacForm): Observable<PortaEquipamentoPac> {
    return this.put(`${this.prefixo}${equipamentoId}/portas`, portaId, form) as Observable<PortaEquipamentoPac>;
  }

  public alterarStatus(equipamentoId: number, portaId: number, ativa: boolean): Observable<PortaEquipamentoPac> {
    return this.patch(`${this.prefixo}${equipamentoId}/portas/${portaId}`, { ativa }) as Observable<PortaEquipamentoPac>;
  }

  public replicar(equipamentoId: number, dto: ReplicarConfigPorta): Observable<PortaEquipamentoPac[]> {
    return this.post(`${this.prefixo}${equipamentoId}/portas/replication`, dto);
  }

  public listarLogReplicacao(equipamentoId: number): Observable<LogReplicacaoPorta[]> {
    return this.get(`${this.prefixo}${equipamentoId}/portas/replication-logs`);
  }

  public salvarGeolocalizacao(equipamentoId: number, form: GeolocalizacaoPortaForm): Observable<PortaEquipamentoPac> {
    return this.patch(`${this.prefixo}${equipamentoId}/portas/geolocation`, form) as Observable<PortaEquipamentoPac>;
  }

  public listarLogGeolocalizacao(equipamentoId: number): Observable<LogGeolocalizacaoPorta[]> {
    return this.get(`${this.prefixo}${equipamentoId}/portas/geolocation-logs`);
  }

  public salvarConfigQrCode(equipamentoId: number, form: ConfigQrCodePortaForm): Observable<PortaEquipamentoPac> {
    return this.patch(`${this.prefixo}${equipamentoId}/portas/qrcode`, form) as Observable<PortaEquipamentoPac>;
  }

  public listarLogQrCode(equipamentoId: number): Observable<LogQrCodePorta[]> {
    return this.get(`${this.prefixo}${equipamentoId}/portas/qrcode-logs`);
  }
}
